export namespace LayoutStateActions {
  export class SetHandset {
    static readonly type = '[LAYOUT] Set handset';
    constructor(public payload: boolean) { }
  }
}
